import { Component, Input, OnChanges } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

type BgClasses =
  | 'bg-gray-600'
  | 'bg-success'
  | 'bg-primary'
  | 'bg-warning'
  | 'bg-white'
  | 'bg-danger';

type IconClasses = 'text-gray-600' | 'text-white';

export interface SoloOrGroupExpectedParams {
  isSolo: boolean;
  iconType: IconTypes;
  showVizientIcon?: boolean;
}

export enum IconTypes {
  COMPLIANT = 'Compliant',
  ALMOST_COMPLIANT = 'Near Compliant',
  NOT_COMPLIANT = 'Under Compliant',
  EXPIRED = 'Expired',
  PENDING = 'No Measurement',
  REVEAL = 'Reveal Only',
  RESPOND_SUBMITTED = 'Submitted',
  RESPOND_BUYER_ANALYZING = 'Buyer Analyzing',
  RESPOND_RESPONSES_DUE_ORANGE = 'Orange',
  RESPOND_RESPONSES_DUE_GREEN = 'Green',
  RESPOND_RESPONSES_DUE_YELLOW = 'Yellow',
}

@Component({
    selector: 'app-solo-or-group-icon',
    templateUrl: './solo-or-group-icon.component.html',
    styleUrls: ['./solo-or-group-icon.component.scss'],
    standalone: false
})
export class SoloOrGroupIconComponent
  implements OnChanges, AgRendererComponent
{
  @Input()
  isSolo = true;

  @Input()
  iconType: IconTypes = IconTypes.COMPLIANT;

  showVizientIcon = false;

  colorClass: BgClasses = 'bg-primary';
  iconClass: IconClasses = 'text-white';

  refresh(): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.setLocalVariables(params.data as SoloOrGroupExpectedParams);
    this.calculateColor();
  }

  ngOnChanges() {
    this.calculateColor();
  }

  setLocalVariables(params: SoloOrGroupExpectedParams) {
    this.isSolo = params.isSolo;
    this.iconType = params.iconType;
    this.showVizientIcon = params.showVizientIcon ?? false;
  }

  calculateColor() {
    switch (this.iconType) {
      case IconTypes.EXPIRED:
        this.colorClass = 'bg-gray-600';
        break;
      case IconTypes.PENDING:
      case IconTypes.RESPOND_SUBMITTED:
      case IconTypes.RESPOND_BUYER_ANALYZING:
        this.colorClass = 'bg-white';
        this.iconClass = 'text-gray-600';
        break;
      case IconTypes.REVEAL:
        this.colorClass = 'bg-success';
        break;
      case IconTypes.COMPLIANT:
      case IconTypes.RESPOND_RESPONSES_DUE_GREEN:
        this.colorClass = 'bg-success';
        break;
      case IconTypes.ALMOST_COMPLIANT:
        this.colorClass = 'bg-warning';
        break;
      case IconTypes.RESPOND_RESPONSES_DUE_ORANGE:
        this.colorClass = 'bg-danger';
        break;
      case IconTypes.RESPOND_RESPONSES_DUE_YELLOW:
        this.colorClass = 'bg-warning';
        break;
      case IconTypes.NOT_COMPLIANT:
        this.colorClass = 'bg-danger';
        break;
    }
  }
}
